import React,{Component} from 'react';
import './ServicesProducts.css';

export default class ServiceProduts extends Component{
    render(){
        return(
            <div>
                <div className="hs-home-sp-main">
                    <div className="hs-home-sp-card-1">
                        <div className="hs-home-sp-card-header-1 wow fadeInLeft">
                        </div>
                        <div className="hs-home-sp-card-body wow fadeInLeft">
                            <h2>
                            Temos os melhores serviços que uma gráfica pode lhe oferecer
                            </h2>
                            <p>
                            Eficancia e agelidade na prestação de serviços, somos compostos por uma equipe altamente especializada e com longos muitos anos de experiencia na prestação de serviços fornecidos pela HS Design.
                            </p>
                        </div>
                    </div>
                    <div className="hs-home-sp-separer"></div>
                    <div className="hs-home-sp-card-2">
                        <div className="hs-home-sp-card-header-2 wow fadeInRight">
                        </div>
                        <div className="hs-home-sp-card-body wow fadeInRight">
                        <h2>
                            Os nossos produtos são totalmente exclusivos
                            </h2>
                            <p>
                            Produtos de design totalmente exclusivos, originais, super criativos e que expressam muita arte e sobre tudo não deixamos de mostrar a cultura angolana, que é a que nos identifica.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}